import React from 'react'
import Modal from 'react-modal'
import styles from './uploader.scss'
import UploaderModal from './uploaderModal'
import UploaderTable from './uploaderTable'

import { getUploadDict, getUploads, showUploadModal } from 'state/actions'
import { connect } from 'react-redux'

const customStyles = {
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(255, 255, 255, 0.75)',
    },
    content: {
        position: 'relative',
        top: 'initial',
        bottom: 'initial',
        left: 'initial',
        right: 'initial',
        maxHeight: '90%',
        overflow: 'auto',
        padding: '0',
    },
}

@connect((state) => {
    let clientAccess = state.app.security.actions
    let canCreateMifid = false

    clientAccess.map((item, key) => {
        if (item.actionName == 'createmifid') {
            canCreateMifid = item.actionAllowed === "true" ? true : false
        }
    })

    let canUpload = false

    clientAccess.map((item, key) => {
        if (item.actionName == 'upload') {
            canUpload = item.actionAllowed === "true" ? true : false
        }
    })


    return ({
        dict: state.uploads.dict,
        uploadInfo: state.uploads.uploadInfo,
        uploadId: state.uploads.uploadId,
        error: state.uploads.error,
        comment: state.uploads.comment,
        modalIsOpen: state.uploads.modalIsOpen,
        step: state.uploads.step,
        done: state.uploads.done,
        groupId: state.uploads.groupId,
        unallocatedFiles: state.uploads.unallocatedFiles,
        files: state.files,
        canCreateMifid,
        canUpload
    })
})
export default class Uploader extends React.Component {
    static propTypes = {
        type: React.PropTypes.string.isRequired,
        id: React.PropTypes.string,
        dispatch: React.PropTypes.func.isRequired,
        uploadInfo: React.PropTypes.array,
        modalIsOpen: React.PropTypes.bool.isRequired,
        selectable: React.PropTypes.bool,
        selected: React.PropTypes.array,
        selectedUpdaterCallback: React.PropTypes.func,
        forceState: React.PropTypes.string,
        forceDescription: React.PropTypes.string,
        clientId: React.PropTypes.string,
        onlyUploadButton: React.PropTypes.bool,
        disableUploadToOracle: React.PropTypes.bool,
        onSelectDocuments: React.PropTypes.func,
        classNameExtra: React.PropTypes.any,
        claimWizardDocType: React.PropTypes.string,
        claimStatusAndQualification: React.PropTypes.any,
    }

    constructor(props) {
        super(props)
        this.state = { isLoaded: false }
    }

    componentDidMount() {
        const { type, id, dispatch, forceState, forceDescription } = this.props

        // create first parallel promise
        let promiseGetUploadDict = new Promise((resolve, reject) => {
            let promiseResult = dispatch(getUploadDict())

            if (promiseResult && (typeof promiseResult.then === "function")) {
                promiseResult.then(() => {
                    return resolve()
                })
            } else {
                return resolve()
            }
        })

        // create second parallel promise
        let promiseGetUploads = new Promise((resolve, reject) => {
            // BEWB-511: we can show tarification upload category without tarification documents
            if (!id) {
                return resolve()
            }
            let promiseResult = dispatch(getUploads(type, id, false))

            if (promiseResult && (typeof promiseResult.then === "function")) {
                promiseResult.then(() => {
                    return resolve()
                })
            } else {
                return resolve()
            }
        })

        // promise all the promises and at the end can pop up the modal if necessary.
        Promise.all([promiseGetUploadDict, promiseGetUploads]).then((values) => {
            this.setState({ isLoaded: true })

            // automatic modal opening when force state of uploading passed by props.
            if (forceState) {
                this.openModal(forceState, forceDescription)
            }

        })

    }

    /**
     * This will be call always when receive props
     * @param {*} nextProps
     */
    componentWillReceiveProps(nextProps) {
        const { forceState } = this.props

        // automatic modal opening when force state of uploading type passed by props.
        // open it just in that case when there are forceState value, else let the user to choose an option by selector
        if (nextProps.forceState !== forceState && nextProps.forceState) {
            this.openModal(nextProps.forceState, nextProps.forceDescription)
        }
    }

    openModal(forceState = null, forceDescription = null) {
        const { type, id, claimStatusAndQualification, claimWizardDocType, dispatch } = this.props

        // when uploader is on claim detail and claim status is 8 or 9 and qualification details are available we should force 
        // required documents for wizard and claim finalization process to the document types === '1'
        if (type === 'claim' && claimStatusAndQualification && (claimStatusAndQualification.claimStatus === '1' || claimStatusAndQualification.claimStatus === '8' || claimStatusAndQualification.claimStatus === '9')) {
            dispatch(showUploadModal(type, id, forceState, forceDescription, claimStatusAndQualification))
            return
        }

        // if uploader is on dsWizard that is opened from claimWizard we need to force a claimWizardDocType to groupType === '1', there should be only this doctype to list
        if (type === 'claim' && claimWizardDocType) {
            dispatch(showUploadModal(type, id, forceState, forceDescription, null, claimWizardDocType))
            return
        }
        dispatch(showUploadModal(type, id, forceState, forceDescription))
    }

    render() {
        const { modalIsOpen, uploadInfo, onlyUploadButton, onSelectDocuments, disableUploadToOracle, type, claimStatusAndQualification,
            classNameExtra, step, claimWizardDocType } = this.props
        const { isLoaded } = this.state
        let isUnfinishedClaim = false
        if (type === 'claim' && claimStatusAndQualification && (claimStatusAndQualification.claimStatus === '1' || claimStatusAndQualification.claimStatus === '8' || claimStatusAndQualification.claimStatus === '9')) {
            isUnfinishedClaim = true
        }

        return (
            <div>
                <UploaderTable
                    {...this.props}
                    openModal={() => this.openModal()}
                    onlyUploadButton={onlyUploadButton}
                    classNameExtra={classNameExtra}
                />
                {uploadInfo && isLoaded &&
                    <Modal
                        isOpen={modalIsOpen}
                        style={{
                            overlay: customStyles.overlay,
                            content: {
                                ...customStyles.content,
                                ...step === 0 && { overflow: 'visible' },
                            },
                        }}
                        className={styles.modal}
                        contentLabel={""}
                    >
                        <UploaderModal {...this.props}
                            onSelectDocuments={onSelectDocuments}
                            disableUploadToOracle={disableUploadToOracle}
                            claimWizardDocType={claimWizardDocType}
                            isUnfinishedClaim={isUnfinishedClaim}
                        />
                    </Modal>
                }
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./components/uploader/index.jsx